import { Fragment } from "react";
import { classNames } from "../helpers";

export default function ProgressHockeyStick(props) {
  function getStage() {
    const customerStage =
      CUSTOMER_STAGES[props.order.warehouse_status.step.toString()];
    return STAGE_TO_INDEX[customerStage];
  }

  return (
    <div className="flex bk2:flex-col bk2:items-center">
      <div className="flex items-end mt-4">
        <div className="flex flex-col">
          <div className="flex text-xs pl-1 w-16">Order Received</div>
          <div
            className={classNames(
              getStage() >= 1 ? "bg-rose-700 text-white" : "",
              "flex w-16 h-8 border-solid border-2 border-rose-700 -skew-x-12"
            )}
          >
            1
          </div>
        </div>
        <div className="flex flex-col ml-1">
          <div className="flex text-xs pl-1 w-16">Sent to Warehouse</div>
          <div
            className={classNames(
              getStage() >= 2 ? "bg-rose-700 text-white" : "",
              "flex w-16 h-8 border-solid border-2 border-rose-700 -skew-x-12"
            )}
          >
            2
          </div>
        </div>
        <div className="flex flex-col ml-1">
          <div className="flex text-xs pl-1 w-16">Packed</div>
          <div
            className={classNames(
              getStage() >= 3 ? "bg-rose-700 text-white" : "",
              "flex w-16 h-8 border-solid border-2 border-rose-700 -skew-x-12"
            )}
          >
            3
          </div>
        </div>
      </div>
      <div className="flex items-end mt-4">
        <div className="flex flex-col ml-1">
          <div className="flex text-xs pl-1 w-16">Quality Control</div>
          <div
            className={classNames(
              getStage() >= 4 ? "bg-rose-700 text-white" : "",
              "flex w-16 h-8 border-solid border-2 border-rose-700 -skew-x-12"
            )}
          >
            4
          </div>
        </div>
        <div className="flex flex-col ml-1 relative">
          <div className="flex text-xs pl-1 w-10 -rotate-60 absolute bottom-12 bk2:rotate-0 bk2:relative bk2:bottom-0">
            Shipped!
          </div>
          <div
            className={classNames(
              getStage() >= 5 ? "bg-rose-700 text-white" : "",
              "flex w-16 h-8 border-solid border-2 border-rose-700 -skew-x-12"
            )}
          >
            5
          </div>
          <div
            className={classNames(
              getStage() >= 5 ? "bg-rose-700" : "",
              "arc border-2 border-solid border-rose-700 absolute bk2:hidden"
            )}
          ></div>
          {getStage() < 5 && (
            <Fragment>
              <div className="border-b-2 border-solid border-gray-100 absolute z-9 blocker-1"></div>
              <div className="border-b-2 border-solid border-gray-100 absolute z-9 blocker-2"></div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
}

const CUSTOMER_STAGES = {
  0: "Order Received",
  1: "Sent to Warehouse",
  2: "Sent to Warehouse",
  3: "Packed",
  4: "Quality Control",
  5: "Quality Control",
  6: "Shipped",
  7: "Delivered",
};

const STAGE_TO_INDEX = {
  "Order Received": 1,
  "Sent to Warehouse": 2,
  Packed: 3,
  "Quality Control": 4,
  Shipped: 5,
  Delivered: 6,
};
